export default {
  state: () => {
    return {
      keepAliveInclude: []
    }
  },
  mutations: {
    setKeepAliveInclude(state, data) {
      if (data.type === 'add') {
        state.keepAliveInclude.push(data.name)
      }
      if (data.type === 'delete') {
        let index = state.keepAliveInclude.indexOf(data.name);
        if (index > -1) {
          state.keepAliveInclude.splice(index, 1);
        }
      }
    },
    resetKeepAliveInclude(state, data) {
      state.keepAliveInclude = [];
    }
  }
}